import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Route-scoped token: pages under /admin/* send the admin token
// (`fa_admin_token`); all other pages send the B2C storefront token
// (`fa_token`). This keeps the two sessions fully independent so logging out
// of the storefront doesn't kill the back-office session.
api.interceptors.request.use((config) => {
  const isAdmin = typeof window !== "undefined" &&
                  window.location &&
                  window.location.pathname.startsWith("/admin");
  const token = localStorage.getItem(isAdmin ? "fa_admin_token" : "fa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
